import axios from "axios";
import { OptionsAbonnement } from "../../Models/Abonnement/AbonnementModels";
import { URL_MIDIS, URLAPI } from "../../Setting";
import { errorService } from "../Error/ErrorService";

export function OptionsAbonnementService(){
    return{

        async getOptionsAbonnement(token:string){
            let options:OptionsAbonnement[]=[];
            try {
                const response = await axios.get(`${URLAPI+'optionsAbonnement'}`, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                      "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                for(const opt of data){
                    options.push({
                        id:opt['id'],
                        nom:opt['nom'],
                        "@id":opt['@id'],
                        quota:opt['quota'],
                        quotaRenouvele:opt['quotaRenouvele'],
                        utilise:opt['utilise'],
                        achete:opt['achete'],
                        typesMessage:opt['typesMessage'],
                        abonnement:{id:0, fluxes:[], exceptionsMusique:[], optionsAbonnement:[], nom:'random', "@id":opt['abonnement']}
                    })
                }
            } catch (error) {
                errorService().handleError('Erreur lors du getOptionsPackFromURLSToPack', error)
                return [];
            }
            return options;
        },

        async getOptionsAbonnementFromUrlToAbonnement(url:string, token:string){
            let option:OptionsAbonnement = {id:0, nom:'', quota:0, quotaRenouvele:0, utilise:0, achete:0, typesMessage:[]}
            try {
                const response = await axios.get(`${URL_MIDIS+url}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                if(data.length>0){
                    option = {
                        id:data[0]['id'],
                        nom:data[0]['nom'],
                        quota:data[0]['quota'],
                        quotaRenouvele:data[0]['quotaRenouvele'],
                        utilise:data[0]['utilise'],
                        "@id":data[0]['@id'],
                        achete:data[0]['achete'],
                        typesMessage:data[0]['typesMessage']
                    };
                }
            } catch (error) {
                errorService().handleError('Erreur lors du getOptionsAbonnementFromUrlToAbonnement', error)
                return;
            }
            return option;
        },

        getOptionsAbonnementFromUrlsToAbonnement(urls:string[], token:string){
            let options:OptionsAbonnement[]=[];
            if(urls.length>0){
                for(const url of urls){
                    try {
                        this.getOptionsAbonnementFromUrlToAbonnement(url, token).then(result=>{if(result)options.push(result)});
                    } catch (error) {
                        errorService().handleError('Erreur lors du getOptionsAbonnementFromUrlsToAbonnement', error)
                        return;
                    }
                }
            }
            return options;
        },

        async postMultiplesOptionsAbonnement(options:OptionsAbonnement[], idAbonnement:number, token:string):Promise<number>{
            let status = 400;
            if(options && options.length>0){
                for(const option of options){
                    try {
                        const postOptionsAbonnementObjet = {
                            "nom": option.nom,
                            "quota": option.quota,
                            "quotaRenouvele": option.quotaRenouvele,
                            "utilise": 0,
                            "achete": 0,
                            "abonnement":idAbonnement,
                            'typesMessage':option.typesMessage.map(type=>type.id)
                        };

                        const reponsePOSTOptionsAbonnement = await axios.post(
                            `${URLAPI+'optionAbonnement'}`,
                            postOptionsAbonnementObjet,
                            {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    'Content-Type': 'application/ld+json',
                                },
                            }
                        )

                        status = reponsePOSTOptionsAbonnement.status;
                    } catch (error) {
                        errorService().handleError('Erreur lors du postMultiplesOptionsAbonnement', error)
                        status = 400;
                    }
                }
            }
            return status;
        },

        async patchOptionsAbonnement(option:OptionsAbonnement, token:string){
            try {
                const patchOptionsAbonnementObjet = {
                    "quota": option.quota,
                    "quotaRenouvele": option.quotaRenouvele ?? option.quota,
                    "utilise": option.utilise ?? 0,
                    "achete": option.achete ?? 0,
                }
    
                const reponsePATCHOptionsAbonnement = await axios.patch(
                    `${URLAPI+'optionAbonnement/'+option.id}`,
                    patchOptionsAbonnementObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );
    
                return reponsePATCHOptionsAbonnement.status;
            } catch (error) {
                errorService().handleError("Erreur lors de la mise à jour d'une option d'abonnement", error)
                return 400;
            }
        },

        async postOptionsAbonnement(option:OptionsAbonnement, idAbonnement:number, token:string){
            try {
                if(!idAbonnement){
                    throw new Error("Absence abonnement relatif à l'option d'abonnement");
                }
                const postOptionsAbonnementObjet = {
                    "nom": option.nom,
                    "quota": option.quota,
                    "quotaRenouvele": option.quotaRenouvele ?? option.quota,
                    "utilise": 0,
                    "achete": 0,
                    "abonnement":idAbonnement,
                    "typesMessage":option.typesMessage.map(type=>type.id)
                }
    
                const reponsePOSTOptionsAbonnement = await axios.post(
                    `${URLAPI+'optionAbonnement'}`,
                    postOptionsAbonnementObjet,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/ld+json',
                        },
                    }
                );
                return {id:reponsePOSTOptionsAbonnement.data['id'], status:reponsePOSTOptionsAbonnement.status};
            } catch (error) {
                errorService().handleError("Erreur lors de l'ajout d'une option d'abonnement", error)
                return {id:-1, status:400};
            }
        }
    }
}